import React, {
  useEffect, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import DatePicker, { CalendarContainer } from 'react-datepicker';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Select from '../../../_common/Form/Selects/Select/Select';
import accountHelpers from '../../../../utils/accountHelpers';
import { getSelectRepListRequest } from '../../../../store/actions/users';

const calendarData = {
  days: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
  months: ['January', 'February', 'March', 'April',
    'May', 'June', 'July', 'August', 'September',
    'October', 'November', 'December'],
};

const locale = {
  localize: {
    day: (n) => calendarData.days[n],
    month: (n) => calendarData.months[n],
  },
  formatLong: {
    date: () => 'yyyy-mm-dd',
  },
};

const limit = 20;

const Calendar = ({
  date, onChange, dateFormat, currentRep, setRep, visitList,
}) => {
  const isAdmin = accountHelpers.isInOneOfRoles(['Admin', 'Pharmacy']);

  const dispatch = useDispatch();

  const { selectRepList, pageCount, currentPage } = useSelector((store) => store.users);

  const changeDate = (currentDate) => {
    onChange(moment(currentDate).format(dateFormat));
  };

  useEffect(() => {
    if (isAdmin) {
      dispatch(getSelectRepListRequest({ limit, role: 'Rep' }));
    }
  }, []);

  const nextOptionListRequest = useCallback(async (repPage) => {
    await dispatch(getSelectRepListRequest({ page: repPage, limit, role: 'Rep' }));
  }, []);

  const renderDayContents = (day, currentDate) => {
    const findDate = visitList.find((l) => l.date === moment(currentDate).format('YYYY-MM-DD'));

    return (
      <div className="agenda_day">
        {day}

        {!!findDate && (
          <div>
            {findDate.repCount > 99 ? '+99' : findDate.repCount}
          </div>
        )}
      </div>
    );
  };

  const calendarContainer = ({ className, children }) => (
    <div className="date_piker_wrapper agenda">
      <CalendarContainer className={className}>
        {isAdmin && (
          <Select
            label="Rep"
            wrapperClassName="calendar_rep_select"
            arrowActiveClassName="arrow_up"
            nextOptionListRequest={nextOptionListRequest}
            options={selectRepList}
            totalPage={pageCount}
            currentPage={currentPage}
            limit={limit}
            currentOption={currentRep}
            labelBG="#f8f8f9"
            onChange={setRep}
            height={40}
            labelDefaultPosition={9}
            optionPathname="name"
          />
        )}

        <div style={{ position: 'relative' }}>{children}</div>
      </CalendarContainer>
    </div>
  );

  return (
    <div className="calendar_wrapper agenda">
      <DatePicker
        inline
        selected={date ? new Date(moment(date).utc().format()) : null}
        onChange={changeDate}
        yearDropdownItemNumber={100}
        showYearDropdown
        // minDate={minDate}
        locale={locale}
        scrollableYearDropdown
        calendarContainer={calendarContainer}
        renderDayContents={renderDayContents}
      />
    </div>
  );
};

Calendar.propTypes = {
  date: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  dateFormat: PropTypes.string,
  currentRep: PropTypes.string.isRequired,
  setRep: PropTypes.func.isRequired,
  visitList: PropTypes.array.isRequired,
};

Calendar.defaultProps = {
  dateFormat: 'MM/DD/YYYY',
  date: null,
};

export default Calendar;
